import { render, staticRenderFns } from "./FllowModal.vue?vue&type=template&id=4aedd4b6&scoped=true"
import script from "./FllowModal.vue?vue&type=script&lang=js"
export * from "./FllowModal.vue?vue&type=script&lang=js"
import style0 from "./FllowModal.vue?vue&type=style&index=0&id=4aedd4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aedd4b6",
  null
  
)

export default component.exports